<template>
  <div id='workUpload'>
    <div class='workUpload-content'>
      <!-- <el-input
      type="textarea" :rows="3" 
      placeholder="请拖拽图片或复制图片地址" 
      v-model="textarea" 
      ></el-input> -->
      <textarea  rows="10" v-model="textarea" class="workupload_textarte" placeholder="请拖拽图片或复制图片地址" ></textarea>
      <span class="upbtncheckt" @click='workUploads'>上传</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'workUpload',
  data() {
    return {
      textarea: ''
    }
  },
  mounted() {
    
  },
  methods: {
    workUploads() {
      const str = this.textarea
      const fileType = str.substring(str.length - 4).toLowerCase()
      if (fileType === '.gif' || fileType === 'jpeg' || fileType === '.jpg' || fileType === '.png' || str.indexOf('yunjiweidian.com') > -1) {
        this.$emit('uploadImg', str)
        this.textarea = ''
      } else {
        this.$message.error('请拖动正确的图片地址')
      }
    }
  }
}
</script>
<style lang="less" scoped>
  #workUpload{
    .workUpload-content{
      position:relative;
      padding-right:40px;
      width:360px;
      input{
        width:100%;
        padding-right:60px;
      }
      .upbtncheckt {
        height:69px;
        background:#409EFF;
        border-radius:3px;
        border-color:#409EFF;
        font-size:16px;
        color:#fff;
        width:60px;
        position:absolute;
        left:300px;
        top:0;
        line-height:69px;
        text-align:center;
      }
    }
    .workupload_textarte {
      padding:5px;
      resize: none;
      width: 100%;
      color: #606266;
      background-color: #FFF;
      background-image: none;
      border: 1px solid #DCDFE6;
      border-radius: 4px;
      height: 68px;
    }
  }
</style>
